import React from "react";
import Sidebar from "../../Sidebar";
import { Link } from "react-router-dom";
import useUser from "../../../hooks/useUser";
import DoctorHeader from "../../../doctor/DoctorHeader";
import profilebgimg from "../../../assets/img/profilebgimg.jpg"
const Profile = () => {
  const user = useUser();
  return (
    <>
      <DoctorHeader />
      <Sidebar />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* <div className="row">
              <div className="col-sm-5 col-6 text-end m-b-30">
                <Link
                  to="/edit-profile"
                  className="btn btn-primary btn-rounded"
                >
                  <i className="fa fa-plus" /> Edit Profile
                </Link>
              </div>
            </div> */}
            <div className="card-box profile-header">
              <div className="row">
                <div className="col-md-12">
                <div className="profile_img">
                <img src={profilebgimg} />
                </div>
                  <div className="profile-view">
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-0">
                              {user?.name}
                            </h3>
                            <small className="text-muted">{user?.role}</small>
                            {/* <div className="staff-id">
                              Employee ID : DR-0001
                            </div> */}
                            {/* <div className="staff-msg">
                              <Link to="/chat" className="btn btn-primary">
                                Send Message
                              </Link>
                            </div> */}
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <span className="title">Phone:</span>
                              <span className="text">
                                <Link to>{user?.phone}</Link>
                              </span>
                            </li>
                            <li>
                              <span className="title">Email:</span>
                              <span className="text">
                                <Link to>{user?.email}</Link>
                              </span>
                            </li>
                            <li>
                              <span className="title">Address:</span>
                              <span className="text">
                                {user?.address}
                              </span>
                            </li>
                            <li>
                              <span className="title">Gender:</span>
                              <span className="text">{user?.gender}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Profile;
